<template>
  <div class="indexModule shopad1" :data="moduleData.Guid">
    <div class="area-market-ad shopad1">
        <div class="head-title">
            <div class="adheadLeft">
                <img  src=" ../../../static/index/bannerbg1-1.png" alt="">
            </div>          
            <div class="adheadMiddle">
                <span class="text" :style="{borderLeft :'2px solid #40A7D2' ,borderRight:'2px solid #40A7D2'}">{{floorData.FloorName}}</span>
            </div>
            <div class="adheadRight">
                <img  src=" ../../../static/index/bannerbg1.png" alt="">
            </div>
            
        </div>
        <div class="ad-list" :style="{height:adHeight+ 'px'}">
            <div class="left">
                <a :href="floorData.AdList[0].Link">
                    <div class="ad-item item1" id="item1">
                        <div class="text-info">
                            <p class="name">{{floorData.AdList[0].Text}}</p>
                            <p class="desc" :style="{color:floorData.AdList[0].Color}">{{floorData.AdList[0].Desc}}</p>
                        </div>
                        <img :src="floorData.AdList[0].Img?floorData.AdList[0].Img:'/static/unknow.gif'" class="ad-img">                     
                    </div>
                </a>     
                <a :href="floorData.AdList[1].Link">
                    <div class="ad-item item1" id="item2">
                        <img :src="floorData.AdList[1].Img?floorData.AdList[1].Img:'/static/unknow.gif'" class="ad-img">
                        <div class="text-info">
                            <p class="name">{{floorData.AdList[1].Text}}</p>
                            <p class="desc" :style="{color:floorData.AdList[1].Color}">{{floorData.AdList[1].Desc}}</p>
                        </div>
                    </div>
                </a>                     
            </div>
            <div class="right">
                <a :href="floorData.AdList[2].Link">
                    <div class="ad-item item2" id="item3">
                         <div class="text-info">
                            <p class="name">{{floorData.AdList[2].Text}}</p>
                            <p class="desc" :style="{color:floorData.AdList[2].Color}">{{floorData.AdList[2].Desc}}</p>
                        </div>
                        <img :src="floorData.AdList[2].Img?floorData.AdList[2].Img:'/static/unknow.gif'" class="ad-img">
                       
                    </div>
                </a>  
            </div>
        </div>
    </div>  
  </div>
</template>

<script>
export default {
  name:'XR-mobile-shopad1',
  data() {
    return {
      adHeight: document.documentElement.clientWidth /1.77     
    }
  },
  props:{
      guid:'',
      configData:{}
  },
  computed:{
    moduleData:function(){
        for(var i=0; i < this.configData.Modules.length;i++){
            var moduleItem = this.configData.Modules[i];
            if(this.guid == moduleItem.Guid){
                return moduleItem;
            }
        }
        return {}
    },
    floorData:function(){
        for(var i = 0; i< this.configData.Floors.length;i++){            
            var floorItem =this.configData.Floors[i];
            if(this.guid == floorItem.Guid){
                return floorItem;
            }
        }
        return {}
    }
  }
}
</script>

<style>
     .shopad1 .btn-list {
        position:absolute;
        top:50%;
        left:15%;
        z-index:999;
        display:none;
    }
    .area-market-ad.shopad1 {
        width:100%;
        background:white;
    }

    .area-market-ad.shopad1 .head-title {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 18px 0 18px;
        background:#EFEFEF;
    }

    .area-market-ad.shopad1 .head-title .adheadLeft{
        width: 33%;
        text-align: right;
    }
    .area-market-ad.shopad1 .head-title .adheadLeft img{
        width: 30px;
    }
    .area-market-ad.shopad1 .head-title .adheadMiddle{
        width: 34%;
        text-align: center;
    }
    .area-market-ad.shopad1 .head-title .adheadRight{
        width: 33%;
        text-align: left;
    }
     .area-market-ad.shopad1 .head-title .adheadRight img{
        width: 30px;
    }
    .area-market-ad.shopad1 .head-title .icon {
        vertical-align: middle;
        height: 40px;
    }

    .area-market-ad.shopad1 .head-title .text {
        vertical-align: middle;
        font-size: 18px;
        border-left:2px solid #333;
        border-right:2px solid #333;
        padding:0 10px;
        color:Black;
    }

    .area-market-ad.shopad1 .head-title .desc {
        vertical-align: sub;
        font-size: 12px;
        border-left: 1px solid red;
        padding-left: 8px;
        margin-left: 5px;
        color: #999;
    }
    .area-market-ad.shopad1 .ad-list {
        width:100%;
        overflow:hidden;
    }
    .area-market-ad.shopad1 .ad-list .ad-item {
        position: relative;
        overflow:hidden;
    }
    .area-market-ad.shopad1 .ad-list .left {
        width:50%;
        height:100%;
        float:left;
    }
    .area-market-ad.shopad1 .ad-list .left .item1 {
        width:100%;
        height:50%;
    }
    .area-market-ad.shopad1 .ad-list .left .item1 .ad-img {
        width:50%;
        height:100%;
        display: block;
    }
    .area-market-ad.shopad1 .ad-list .left .item1 .text-info {
        position:absolute;
        top:10%;
        width:50%;
        text-align: center;
    }
    .area-market-ad.shopad1 .ad-list .left #item1 .text-info{
        right: 0;
    }
    .area-market-ad.shopad1 .ad-list .left #item2 .text-info{
        left: 0;
    }
    .area-market-ad.shopad1 .ad-list .left #item2 .ad-img{
        float: right;
    }
    .area-market-ad.shopad1 .ad-list .left .item1 .text-info .name {
        font-size:16px;
        color:#676565;
        text-align: center;
    }
    .area-market-ad.shopad1 .ad-list .left .item1 p{
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }
    .area-market-ad.shopad1 .ad-list .left .item1 .text-info .desc {
        line-height:16px;
        font-size:12px;
    }
    .area-market-ad.shopad1 .ad-list .right {
        width:50%;
        height:100%;
        float:right;
    }
    .area-market-ad.shopad1 .ad-list .right .item2 {
        width:100%;
        height:100%;
    }
    .area-market-ad.shopad1 .ad-list .right .item2 .ad-img {
        width:100%;
        height:73%;
        display: block;
    }
    .area-market-ad.shopad1 .ad-list .right .item2 .text-info {
            text-align: center;
            position: static;
            width: 70%;
            height: 22%;
            margin: 5% auto 0;
            
    }
    .area-market-ad.shopad1 .ad-list .right .item2 .text-info .name {
        font-size:16px;
        text-align:center;
        color:#676565;
            text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }
    .area-market-ad.shopad1 .ad-list .right .item2 .text-info .desc {
        line-height:16px;
        font-size:12px;
        text-align:center;
            text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }
</style>



// WEBPACK FOOTER //
// src/components/index/mobile/shopad1/ad1.vue